import React from "react";
import { Button } from "react-bootstrap";
import { AttachmentUploadProps, FileWithPreview } from "../../../libs";

export const AttachmentUpload: React.FC<AttachmentUploadProps> = ({ onFilesSelected, buttonText }) => {
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const filesArray: FileWithPreview[] = Array.from(event.target.files).map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
      }));
      onFilesSelected(filesArray);
    }
  };

  return (
    <>
      <Button variant="light" onClick={() => document.getElementById("fileInput")?.click()}>
        {buttonText || "Upload Attachments"}
      </Button>
      <input
        id="fileInput"
        type="file"
        accept="image/jpeg, image/png"
        multiple
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
    </>
  );
};
